import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import { trackClickCTA } from "../lib/pixel";
import { PACKAGES } from "../config/site";
import { usePresaleCountdown } from "../lib/presale";

export const StickyMobileCta = () => {
    const [visible, setVisible] = useState(false);
    const { ended, lastDay, promoActive, promoTime } = usePresaleCountdown();

    useEffect(() => {
        const pricing = document.querySelector("#pakiety");
        let pricingVisible = false;

        const onScroll = () => {
            setVisible(!pricingVisible && window.scrollY > window.innerHeight * 0.85);
        };

        let observer;
        if (pricing) {
            observer = new IntersectionObserver(
                ([entry]) => {
                    pricingVisible = entry.isIntersecting;
                    onScroll();
                },
                { threshold: 0.05 },
            );
            observer.observe(pricing);
        }

        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
            observer?.disconnect();
        };
    }, []);

    return (
        <div
            data-testid="sticky-mobile-cta-bar"
            aria-hidden={!visible}
            className={`fixed bottom-4 inset-x-0 z-40 flex justify-center px-4 pointer-events-none transition-all duration-500 lg:justify-end lg:pr-10 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
        >
            <div className="pointer-events-auto flex items-center gap-3 bg-ink text-white pl-5 pr-2 py-2 rounded-full shadow-2xl">
                <span className="text-xs font-bold whitespace-nowrap leading-tight">
                    {ended
                        ? "Kurs online"
                        : promoActive
                          ? promoTime.lastDay
                              ? "Tylko dziś!"
                              : "Tylko 27.10"
                          : "Early Bird"}
                    <span className="block text-tang">
                        {ended
                            ? `od ${PACKAGES[0].regularPrice} zł`
                            : promoActive
                              ? "kod MINUS50 = -50 zł"
                              : `od ${PACKAGES[0].presalePrice} zł`}
                    </span>
                    {!ended && !promoActive && (
                        <span className="block text-[10px] text-[#FFB3BC] font-semibold">
                            {lastDay ? "Ostatni dzień!" : "do 30.10, 23:59"}
                        </span>
                    )}
                </span>
                <button
                    data-testid="sticky-mobile-cta-button"
                    onClick={() => {
                        trackClickCTA("sticky-mobile");
                        scrollToId("#pakiety");
                    }}
                    tabIndex={visible ? 0 : -1}
                    className="inline-flex items-center gap-1.5 rounded-full bg-tang hover:bg-[#EFE238] text-ink font-bold px-4 min-h-[44px] text-sm transition-colors whitespace-nowrap"
                >
                    Kupuję kurs
                    <ArrowRight className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};
